import { useEffect, useState } from "react";
import ModalWindow from "../../common/ModalWindow";
import ReactDatePicker from "react-datepicker";

const ScheduleWorkOrderWindow: React.FC<{
  workOrderScheduledDate: Date | undefined;
  setShowScheduleWorkOrderWindow: any;
  onScheduleWorkOrder: any;
}> = ({
  workOrderScheduledDate,
  setShowScheduleWorkOrderWindow,
  onScheduleWorkOrder,
}) => {
  const [isOkEnabled, setIsOkEnabled] = useState<boolean>(false);

  const [scheduledDate, setScheduledDate] = useState<Date | undefined>();

  useEffect(() => {
    setScheduledDate(workOrderScheduledDate);

    const hasScheduleDate = workOrderScheduledDate !== undefined;
    setIsOkEnabled(hasScheduleDate);
  }, [workOrderScheduledDate]);

  const onScheduleWorkOrderOk = async () => {
    await onScheduleWorkOrder(scheduledDate);
    setShowScheduleWorkOrderWindow(false);
  };

  const onScheduleWorkOrderCancel = () => {
    setShowScheduleWorkOrderWindow(false);
  };

  const onScheduleWorkOrderScheduledDateChanged = (date: Date | undefined) => {
    setIsOkEnabled(date !== undefined);
    setScheduledDate(date);
  };

  return (
    <ModalWindow
      title="Schedule Work Order"
      okTitle="Schedule"
      onOk={onScheduleWorkOrderOk}
      onCancel={onScheduleWorkOrderCancel}
      isOkEnabled={isOkEnabled}
    >
      <div>
        <div className="mb-2" style={{ fontWeight: "bold" }}>
          Provide an ETA (Scheduled Date)
        </div>
        <div className="calendar-textbox-full-width">
          <ReactDatePicker
            className="form-control"
            placeholderText="Please select"
            id="scheduledDate"
            selected={scheduledDate}
            onChange={(date: Date) =>
              onScheduleWorkOrderScheduledDateChanged(date)
            }
            popperPlacement="bottom-start"
            minDate={new Date()}
          />
        </div>
      </div>
    </ModalWindow>
  );
};

export default ScheduleWorkOrderWindow;
